import { useDataTableUsingState, useDataTableUsingUrl, } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { useMediaQuery } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAlerts } from './useAlerts';
export function useAlertsTable({ useDataTableFunction = useDataTableUsingState, staticFilterData, initialFilterData, filterConfig, defaultSortColumnKey = 'createdAt', handleRowClickDialog, }) {
    const location = useLocation();
    const navigate = useNavigate();
    const upLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    const result = useDataTableFunction({
        useDataProvider: (request) => {
            const alerts = useAlerts(Object.assign(Object.assign({}, request), { filterData: Object.assign(Object.assign({}, staticFilterData), request.filterData) }));
            return {
                data: alerts.data
                    ? {
                        rows: alerts.data.items,
                        filteredRowCount: alerts.data.totalCount,
                    }
                    : undefined,
                error: alerts.error,
                isLoading: alerts.isLoading,
                reload: alerts.mutate,
            };
        },
        onRowClick: (row) => (handleRowClickDialog ? (upLgScreen ? undefined : handleRowClickDialog(row.id)) : undefined),
        rowSelectionEnabled: true,
        defaultSortColumnKey: defaultSortColumnKey,
        defaultSortColumnDesc: true,
        initialFilterData,
    });
    return Object.assign(Object.assign({}, result), { dataTableProps: Object.assign(Object.assign({}, result.dataTableProps), { columns: [], filtersBar: filterConfig ? React.createElement(FiltersBar, Object.assign({}, result.filtersBarProps, { config: filterConfig })) : undefined }), clearActiveRow: useDataTableFunction === useDataTableUsingUrl
            ? () => {
                const newSearchParams = new URLSearchParams(location === null || location === void 0 ? void 0 : location.search);
                const activeRowId = newSearchParams.get('id');
                newSearchParams.delete('id');
                let newState = location.state;
                if (activeRowId && newState.selectedRowIds && newState.selectedRowIds.includes(activeRowId)) {
                    newState = Object.assign(Object.assign({}, newState), { selectedRowIds: newState.selectedRowIds.filter((id) => id != activeRowId) });
                }
                navigate({ pathname: '.', search: newSearchParams.toString() }, { state: newState, replace: true });
            }
            : result.clearActiveRow });
}
